import useUser from '../../../../Shared/UserProvider/useUser'
import { useQuery } from '@tanstack/react-query'
import { getIntegrationState } from '../../../../../services/Provider/Provider.service'
import { IntegrationStateCard } from './IntegrationStateCard'
import { IntegrationStateCardLoadingPlaceholder } from './IntegrationStateCardLoadingPlaceholder'


const IntegrationStateCards = () => {
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['integration-state', user.provider.id],
        queryFn: () => getIntegrationState(user.provider.id),
    })

    if (isLoading) {
        return <IntegrationStateCardLoadingPlaceholder />
    }

    return (
      <>
          {data.map((integrationState, index) => (
            <IntegrationStateCard
              key={index}
              integrationState={integrationState}
            />
          ))}
      </>
    )
}

export { IntegrationStateCards }
